<template>
  <l-layout :layout="['xs12']">
    <v-form ref="parkForm">
      <v-card class="pa-3">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="园区名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag">
              </v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="园区等级" prepend-icon="$vuetify.icons.level" v-model="form.level" :disabled="disabledFlag">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-select label="所属机构" prepend-icon="$vuetify.icons.group" :items="form.orgSelect" v-model="form.org"
                        :disabled="disabledFlag"
                        item-text="name" item-value="id"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="园区描述" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow v-model="form.description" :disabled="disabledFlag">
              </v-textarea>
            </v-flex>
          </v-layout>
          <v-layout column v-if="form.qrcodeUrl!==''">
            <v-flex xs2 class="pl-4">
              <h3>园区二维码展示</h3>
            </v-flex>
            <v-flex xs2>
              <img :src="form.qrcodeUrl" style="width:200px;height:200px">
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout justify-center>
          <v-btn class="primary" @click="disabledFlag=!disabledFlag" v-if="disabledFlag">修改</v-btn>
          <v-btn class="primary" :loading="loading" :disabled="disabledFlag"  v-if="!disabledFlag" @click="updateParkInfo">提交</v-btn>
          <v-btn class="primary" :loading="loading" @click="getParkQrcode">生成园区二维码</v-btn>
        </v-layout>
      </v-card>
    </v-form>
  </l-layout>
</template>

<script>
export default {
  name: 'parkDetails',
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      form: {
        org: '',
        name: '',
        level: '',
        description: '',
        parentParksId: [],
        orgSelect: [],
        parentParkSelect: [],
        qrcodeUrl: ''
      },
      loading: false,
      disabledFlag: true,
    }
  },
  created () {
    this.initFormData()
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    initFormData () {
      this.form.name = this.formData.name
      this.form.description = this.formData.description
      this.form.level = this.formData.parkLevel
      this.getOrgSelect()
      this.form.org = this.formData.institutionId
      this.dealParentParks()
      if(this.formData.extend!==null){
        let extend = JSON.parse(this.formData.extend)
        this.form.qrcodeUrl = '/qrcode' + extend.qrcodePicPath
      }
    },
    async dealParentParks () {
      console.log(this.formData)
      /* let ids = this.formData.parentParksId
      for (let i = 0; i < ids.length; i++) {
        let {items} = await this.$store.dispatch('park/getParkList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'id', value: ids[i]},
        })
        this.form.parentParksId.push(items[0])
      } */
    },
    async getOrgSelect () {
      try {
        let items = await this.$store.dispatch('login/getAvailableIns')
        this.form.orgSelect = items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    async getParksByName (val) {
      try {
        let {items} = await this.$store.dispatch('park/getParkList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    checkForm () {
      return true
    },
    async updateParkInfo () {
      if (this.checkForm()) {
        let ids = []
        for (let i = 0; i < this.form.parentParksId.length; i++) {
          ids.push(this.form.parentParksId[i].id)
        }
        let params = {
          'id': this.formData.id,
          'name': this.form.name,
          'description': this.form.description,
          'parkLevel': this.form.level,
          'institutionId': this.form.org,
          'latitude': '',
          'longitude': '',
        }
        this.loading = true
        let res = await this.$store.dispatch('park/updateParkInfo', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.$L.alert('success', {message: '修改成功'})
          this.disabledFlag = true
        }
        else {
          this.$L.alert('error', {message: '修改失败，原因：' + res.data.msg})
        }
      }
    },
    async getParkQrcode () {
      let ids = []
      for (let i = 0; i < this.form.parentParksId.length; i++) {
        ids.push(this.form.parentParksId[i].id)
      }
      let params = {
        'id': this.formData.id,
        'name': this.form.name,
        'description': this.form.description,
        'parkLevel': this.form.level,
        'institutionId': this.form.org,
        'latitude': '',
        'longitude': '',
        'extend': {
          'qrcodeStr': {
            '1': 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=',
            '2': 'https://smaco2.uestc.edu.cn/wx/autoLogin?aim=searchBill-parkId-' + this.formData.id,
            '3': '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
          }
        }
      }
      this.loading = true
      let res = await this.$store.dispatch('park/updateParkInfo', params)
      this.loading = false
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '生成二维码成功'})
        let data = JSON.parse(res.data.data.extend)
        this.form.qrcodeUrl = '/qrcode' + data.qrcodePicPath
        this.disabledFlag = true
      }
      else {
        this.$L.alert('error', {message: '生成二维码失败，原因：' + res.data.msg})
      }
    }
  }
}
</script>

<style scoped>

</style>
